import React, { useContext } from 'react';
import { shape, string } from 'prop-types';
import {
  Card,
  CardContent,
  CardMedia,
  Typography
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong on our end. '
+ 'Please refresh the page or try again later— we’re working on it!';

const ExceptionMessage = ({ data = {} }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const { description, referenceUrl } = data;

  return (
    <div data-testid="exception-error-message" className={!isMobile ? 'sui-p-4 sui-my-4' : 'sui-my-4'}>
      <Card
        href={referenceUrl}
        orientation="vertical"
      >
        <CardContent orientation="horizontal" initialSize="2/4">
          <CardMedia
            src="https://assets.thdstatic.com/images/v1/oops.svg"
            width="min"
            alt="oops"
          />
        </CardContent>
        <Typography variant="body-base" height="loose">
          {description || DEFAULT_ERROR_MESSAGE}
        </Typography>
      </Card>
    </div>
  );
  // const telephoneLink = 'tel:' + telephoneNumber;
  // return (
  //   <div data-testid="exception-message">
  //     <MessageBubble type="bot">
  //       <div>
  //         {description}
  //       </div>
  //       <Link href={telephoneLink} underline="always">{'tel: ' + telephoneNumber}</Link>
  //     </MessageBubble>
  //   </div>
  // );
};

ExceptionMessage.propTypes = {
  data: shape({
    telephoneNumber: string,
    description: string,
    referenceUrl: string
  }).isRequired,
};

export { ExceptionMessage };
